import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, IDropdown, IDropdownOption, ResponsiveMode } from 'office-ui-fabric-react/lib/Dropdown';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import Label from 'reactstrap/lib/Label';
import XRegExp from 'xregexp';
import { IAgentChargesWithLog } from '../../../models/IAgentChargesWithLog';
import { IAgentSpecificNegotiation } from '../../../models/IAgentSpecificNegotiation';
import { ICharges } from '../../../models/ICharges';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentChargesUpdatePreview from '../AgentChargesUpdatePreview/AgentChargesUpdatePreview';
import { IAgentChargesUpdateProps } from './IAgentChargesUpdateProps';
import { IAgentChargesUpdateState } from './IAgentChargesUpdateState';
initializeIcons();

const panel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0"
});
const disableInput = mergeStyles({
    pointerEvents: "none",
    opacity: "0.5"
});
const enableInput = mergeStyles({
    display: 'block'
});
const searchDivContainer = mergeStyles({
    margin: '0 auto ',
    padding: '10px',
    border: '1px solid #005269',
    width: '100%',
    textAlign: 'center',
    backgroundColor: '#ECEAE6'
});
const searchDiv = mergeStyles({
    fontWeight: 'bold',
    display: 'inline-block',
    margin: "10px",
    verticalAlign: 'middle'
});
const modifiedBox = mergeStyles({
    textAlign: "right", width: "50px", backgroundColor: "#E5CFCB"
});
const nonModifiedBox = mergeStyles({
    textAlign: "right", width: "50px"
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    border: "1px solid #005269"
});
const responsiveTableContent = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%"
});
const responsiveTableRow = mergeStyles({
    display: "table-row"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269",
    backgroundColor: '#005269', color: "#ffffff"

});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle"
});
const responsiveTableBodyCellCenter = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "center",
    verticalAlign: "middle"
});
const responsiveTableBodyCellParticulars = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle",
    width: "40%"
});
const responsiveTableBodyCellRight = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "right"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
const alertMsgPanel = mergeStyles({
    color: "#E9512D", fontSize: "13px", textAlign: "left"
});
export interface IDetailsListGroupedItem {
    key: number;
    particulars: string;
    officialfee: number;
    professionalfee: number;
    otherexpenses: number
    total: number;
    notapplicable: boolean;
}
export const AgentChargesGeneral = ({ agentCharges, parent }) => {
    const handleFocus = (event) => event.target.select();
    return (
        <div className={responsiveMain}>
            <div className={responsiveTable}>
                <div className={responsiveTableBody}>
                    <div className={responsiveTableHeaderRow}>
                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                        <div className={responsiveTableBodyCellCenter}><strong>Official fee (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Professional fee (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Other fee (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Total (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>N.A</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        agentCharges.map((tech, i) => {
                            return (
                                <div className={responsiveTableRow}>
                                    <div className={responsiveTableBodyCellParticulars}>{tech.particulars}</div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.officialfeeOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.officialfee} className={tech.officialfeeOld !== tech.officialfee ? modifiedBox : nonModifiedBox} accessKey={tech.id} onChange={e => parent.onOfficialFeeChange(i, e)} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.professionalfeeOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.professionalfee} className={tech.professionalfeeOld !== tech.professionalfee ? modifiedBox : nonModifiedBox} accessKey={tech.id} onChange={e => parent.onProfessionalFeeChange(i, e)} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.otherexpensesOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.otherexpenses} className={tech.otherexpensesOld !== tech.otherexpenses ? modifiedBox : nonModifiedBox} accessKey={tech.id} onChange={e => parent.onOtherExpensesChange(i, e)} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.totalOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.total} className={tech.totalOld !== tech.total ? modifiedBox : nonModifiedBox} accessKey={tech.id} disabled onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicableOld} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicable} onChange={parent.onNAClick} accessKey={tech.id} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
export const AgentChargesHourlyRate = ({ agentCharges, parent }) => {
    const handleFocus = (event) => event.target.select();
    return (
        <div className={responsiveMain}>
            <div className={responsiveTable}>
                <div className={responsiveTableBody}>
                    <div className={responsiveTableHeaderRow}>
                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                        <div className={responsiveTableBodyCellCenter}><strong>Paralegal level (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Associate level  (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Partner level (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Total (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>N.A</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        agentCharges.map((tech, i) => {
                            return (
                                <div className={responsiveTableRow}>
                                    <div className={responsiveTableBodyCellParticulars}>{tech.particulars}</div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.officialfeeOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.officialfee} className={tech.officialfeeOld !== tech.officialfee ? modifiedBox : nonModifiedBox} accessKey={tech.id} onChange={e => parent.onOfficialFeeChange(i, e)} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.professionalfeeOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.professionalfee} className={tech.professionalfeeOld !== tech.professionalfee ? modifiedBox : nonModifiedBox} accessKey={tech.id} onChange={e => parent.onProfessionalFeeChange(i, e)} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.otherexpensesOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.otherexpenses} className={tech.otherexpensesOld !== tech.otherexpenses ? modifiedBox : nonModifiedBox} accessKey={tech.id} onChange={e => parent.onOtherExpensesChange(i, e)} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.totalOld} className={nonModifiedBox} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="text" value={tech.total} className={tech.totalOld !== tech.total ? modifiedBox : nonModifiedBox} accessKey={tech.id} disabled onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicableOld} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicable} onChange={parent.onNAClick} accessKey={tech.id} onFocus={handleFocus} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
export default class AgentChargesUpdate extends React.Component<IAgentChargesUpdateProps, IAgentChargesUpdateState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private saving: boolean = false;
    private CountryError: string;
    private isActive: boolean;
    focusInput: React.RefObject<HTMLDivElement>;

    constructor(props: IAgentChargesUpdateProps, state: IAgentChargesUpdateState) {
        super(props);
        this.focusInput = React.createRef();
        this.focus = this.focus.bind(this);
        this.connectionContext = this.props.connectionContext;
        this.CountryError = '';
        this.isActive = false;

        this.state = {
            agentMaster: this.props.agentMaster,
            loading: false,
            inputError: 'This field is Required',
            showError: false,
            isValidData: true,
            Countries: [],
            selectedCountry: {
                key: '',
                text: ''
            },
            hideDialog: true,
            charges: [],
            agentCharges: [],
            selectedcountries: '',
            hideModel: true
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async focus() {
        const node = this.focusInput.current;
        if (node) {
            node.focus();
        }
    }
    private changeCountry(item: IDropdownOption) {
        this.setState((prevState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            prevState.selectedCountry = item;
            const re = XRegExp('^[\\p{L}]+$');
            this.CountryError = '';
            if (item.key.toString().trim().length != 2 || !re.test(item.key.toString())) {
                this.CountryError = 'Select a jurisdiction';
            }
            this.saving = false;
            return prevState;
        }, () => this.getAgentCharges());
    }
    public async componentDidMount() {
        if (this.state.agentMaster.id !== null && this.state.agentMaster.id !== undefined && this.state.agentMaster.id !== "") {
            this.getJurisdiction();
            this.getCharges();
        }
        this.focus();
    }
    private getJurisdiction = async (): Promise<void> => {
        let result: IDropdownOption[] = [];
        result.push(
            { key: '--Select--', text: '--Select--' });

        var selectedcountries = '';
        let agentSpecificNegotiations: IAgentSpecificNegotiation[] = await this.connectionContext.get(`AgentCharges/${this.state.agentMaster.id}`);
        this.setState((prevState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            agentSpecificNegotiations.forEach((item: IAgentSpecificNegotiation) => {
                result.push({
                    key: item.countryCode, text: item.countryName
                });
                if (selectedcountries === '') {
                    selectedcountries = item.countryName;
                }
                else {
                    selectedcountries = selectedcountries + ', ' + item.countryName;
                }
            });
            prevState.selectedcountries = selectedcountries;
            prevState.Countries = result;
            prevState.selectedCountry.key = "--Select--";
            prevState.selectedCountry.text = "--Select--";
            return prevState;
        });
    }
    private getCharges = async (): Promise<void> => {
        try {
            let result: IAgentChargesWithLog[] = [];
            let agentCharges: ICharges[] = await this.connectionContext.get("Charges");
            this.setState((prevState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
                prevState.charges = agentCharges;
                agentCharges.forEach((item: any) => {
                    result.push({
                        id: item.id, agentId: this.state.agentMaster.id || "", countryCode: item.countryCode, countryName: item.countryName, particulars: item.particulars, officialfee: item.officialfee | 0, professionalfee: item.professionalfee | 0,
                        otherexpenses: item.otherexpenses | 0, total: item.total | 0, category: item.category, notApplicable: false, officialfeeOld: 0, professionalfeeOld: 0, otherexpensesOld: 0, notApplicableOld: false, totalOld: 0
                    });
                });
                prevState.agentCharges = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private getAgentCharges = async (): Promise<void> => {
        try {
            if (this.state.selectedCountry.text.toString() != null && this.state.selectedCountry.text.toString() !== "" && this.state.selectedCountry.text.toString() !== undefined) {
                let agentCharges: IAgentChargesWithLog[] = await this.connectionContext.get(`AgentCharges/${this.state.agentMaster.id}/${this.state.selectedCountry.key}/withlog`);
                this.setState((prevState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
                    prevState.agentCharges = agentCharges;
                    this.isActive = true;
                    if (prevState.agentCharges.length === 0) {
                        this.getCharges();
                        this.isActive = false;
                    }
                    return prevState;
                });
            }
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private onNAClick = (item) => {
        const isChecked = item.target.checked;
        const key = item.target.accessKey;
        const value = item.target.value;
        this.setState((previousState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            previousState.agentCharges.forEach((tech: IAgentChargesWithLog) => {
                if (tech.particulars === value && tech.id === key) {
                    tech.notApplicable = isChecked;
                    tech.officialfee = 0;
                    tech.professionalfee = 0;
                    tech.otherexpenses = 0;
                    tech.total = 0;
                }
            });
            return previousState;
        });
    }
    private onOfficialFeeChange = (i, event) => {
        const value = event.target.value;
        const key = event.currentTarget.accessKey;

        this.setState((previousState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            previousState.agentCharges.forEach((tech: IAgentChargesWithLog) => {
                if (tech.id === key) {
                    const re = /^[0-9]\d*(\.\d+)?$/;
                    if (value.length < 1) {
                        tech.officialfee = 0;
                    }
                    else if (!re.test(value)) {
                        event.preventDefault();
                        tech.officialfee = 0;
                    }
                    else {
                        tech.officialfee = parseFloat(value);
                        tech.notApplicable = false;
                    }
                    tech.professionalfee = (tech.professionalfee === null || tech.professionalfee === 0 || tech.professionalfee === undefined) ? 0 : tech.professionalfee;
                    tech.otherexpenses = (tech.otherexpenses === null || tech.otherexpenses === 0 || tech.otherexpenses === undefined) ? 0 : tech.otherexpenses;;
                    tech.total = (tech.officialfee) + (tech.professionalfee) + (tech.otherexpenses);

                }
            });
            return previousState;
        });
    }
    private onProfessionalFeeChange = (i, event) => {
        const value = event.target.value;
        const key = event.currentTarget.accessKey;

        this.setState((previousState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            previousState.agentCharges.forEach((tech: IAgentChargesWithLog) => {
                if (tech.id === key) {
                    const re = /^[0-9]\d*(\.\d+)?$/;
                    if (value.length < 1) {
                        tech.professionalfee = 0;
                    }
                    else if (!re.test(value)) {
                        event.preventDefault();
                        tech.professionalfee = 0;
                    }
                    else {
                        tech.professionalfee = parseFloat(value);
                        tech.notApplicable = false;
                    }
                    tech.officialfee = (tech.officialfee === null || tech.officialfee === 0 || tech.officialfee === undefined) ? 0 : tech.officialfee;
                    tech.otherexpenses = (tech.otherexpenses === null || tech.otherexpenses === 0 || tech.otherexpenses === undefined) ? 0 : tech.otherexpenses;;
                    tech.total = (tech.officialfee) + (tech.professionalfee) + (tech.otherexpenses);
                }
            });
            return previousState;
        });
    }
    private onOtherExpensesChange = (i, event) => {
        const value = event.target.value;
        const key = event.currentTarget.accessKey;

        this.setState((previousState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            previousState.agentCharges.forEach((tech: IAgentChargesWithLog) => {
                if (tech.id === key) {
                    const re = /^[0-9]\d*(\.\d+)?$/;
                    if (value.length < 1) {
                        tech.otherexpenses = 0;
                    }
                    else if (!re.test(value)) {
                        event.preventDefault();
                        tech.otherexpenses = 0;
                    }
                    else {
                        tech.otherexpenses = parseFloat(value);
                        tech.notApplicable = false;
                    }
                    tech.professionalfee = (tech.professionalfee === null || tech.professionalfee === 0 || tech.professionalfee === undefined) ? 0 : tech.professionalfee;
                    tech.officialfee = (tech.officialfee === null || tech.officialfee === 0 || tech.officialfee === undefined) ? 0 : tech.officialfee;;
                    tech.total = (tech.officialfee) + (tech.professionalfee) + (tech.otherexpenses);
                }
            });
            return previousState;
        });
    }
    private closeChild = async (): Promise<void> => {
        this.setState((prevState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            prevState.hideDialog = true;
            this.isActive = false;
            return prevState;
        });
        await this.getJurisdiction();
        await this.getCharges();
        this.focus();
    };
    private cancelChild = () => {
        this.setState({
            hideDialog: true
        });
        this.focus();
    };
    public render(): React.ReactElement<IAgentChargesUpdateProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const dropdownRef = React.createRef<IDropdown>();
        const trademarkitems = this.state.agentCharges.filter(tech => tech.category === "TRADE MARK");
        const patentsitems = this.state.agentCharges.filter(tech => tech.category === "PATENTS");
        const designitems = this.state.agentCharges.filter(tech => tech.category === "DESIGN");
        const hourlyrateitems = this.state.agentCharges.filter(tech => tech.category === "HOURLY RATE PROSECUTION");
        return (
            <div>
                <div ref={this.focusInput}></div>
                <div className={panel} >
                    {
                        <div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideModel}
                                    dialogContentProps={{
                                        type: DialogType.largeHeader,
                                        title: this.dialog.dialogMessage,
                                    }}
                                    maxWidth="1024px"
                                    closeButtonAriaLabel="Close"
                                >
                                    <div>
                                        <div>
                                            <Label> {this.dialog.dialogBody} </Label>
                                        </div>
                                    </div>
                                    <DialogFooter>
                                        <DefaultButton onClick={this.closeModelPopUp} data-automation-id="test" text="Ok" disabled={false}
                                            className={submitButton} iconProps={{ iconName: "CheckMark" }} />
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        </div>
                    }
                    {
                        <div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideDialog}
                                    dialogContentProps={{
                                        type: DialogType.largeHeader,
                                        title: this.dialog.dialogMessage,
                                    }}
                                    minWidth="80%"
                                    maxWidth="90%"
                                    closeButtonAriaLabel="Close"
                                >
                                    <div>
                                        <div>
                                            <AgentChargesUpdatePreview connectionContext={this.connectionContext}
                                                agentCharges={this.state.agentCharges} onCancel={this.cancelChild} onClose={this.closeChild}
                                                selectedCountry={this.state.selectedCountry.text} selectedcountries={this.state.selectedcountries} />
                                        </div>
                                    </div>
                                </Dialog>
                            </div>
                        </div>
                    }
                    {
                        (!this.saving) && (
                            <div>
                                <div>
                                    <div className={searchDivContainer}>
                                        <div className={searchDiv}>Select a jurisdiction to view/revise the charges  : </div>
                                        <div className={searchDiv}>
                                            <Stack tokens={stackTokens} verticalAlign="center">
                                                <Dropdown
                                                    id="ddjur"
                                                    placeHolder="--Select--"
                                                    componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                    options={this.state.Countries}
                                                    required={true}
                                                    styles={{ dropdown: { minWidth: 150 } }}
                                                    onChanged={this.changeCountry.bind(this)}
                                                    errorMessage={this.CountryError}
                                                    selectedKey={this.state.selectedCountry.key}
                                                />
                                            </Stack>
                                        </div>
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>TRADE MARK</h6>
                                        <AgentChargesGeneral agentCharges={trademarkitems} parent={this} />
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>PATENTS</h6>
                                        <AgentChargesGeneral agentCharges={patentsitems} parent={this} />
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>DESIGN</h6>
                                        <AgentChargesGeneral agentCharges={designitems} parent={this} />
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>HOURLY RATE PROSECUTION</h6>
                                        <AgentChargesHourlyRate agentCharges={hourlyrateitems} parent={this} />
                                    </div>
                                </div>
                                {(this.isActive &&
                                    <div>
                                        <div className={alertMsgPanel}>Please make sure you have entered the correct values before submitting. Once submitted, it cannot be modified.
                                            In future, if there is any correction in the charges, please contact agent.network@zacco.com.
                                        </div>
                                        <span className={alertMsgPanel}> * </span> Mandatory  <br />
                                        <PrimaryButton text="Preview & Submit" onClick={this.submitForm} className={submitButton}
                                            iconProps={{ iconName: 'ComplianceAudit' }} />
                                    </div>)}
                            </div>)}
                </div>
            </div >);
    }
    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            this.setState((previousState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
                previousState.hideDialog = false;
                return previousState;
            });
        }
    }
    private closeModelPopUp = () => {
        this.setState((previousState: IAgentChargesUpdateState, props: IAgentChargesUpdateProps): IAgentChargesUpdateState => {
            previousState.hideModel = true;
            return previousState;
        });
    }
    private checkMandatoryFields(): boolean {
        let validState: boolean = true;
        this.CountryError = '';
        let selectedCountryCode: boolean = this.state.selectedCountry.key.toString().trim().length == 2;
        let selectedCountryName: boolean = this.state.selectedCountry.text.toString().trim().length > 0;
        let datalength: boolean = this.state.agentCharges.length > 0;
        const regexCode = XRegExp('^[\\p{L}]+$');
        if (!selectedCountryCode || !regexCode.test(this.state.selectedCountry.key.toString())) {
            this.CountryError = 'Select a jurisdiction';
            this.handleError("Warning", "Select a jurisdiction");
            validState = false;
        }
        const regexName = XRegExp('^[\\p{L}\\p{Pd} ]+$');
        if (!selectedCountryName || !regexName.test(this.state.selectedCountry.text.toString())) {
            this.CountryError = 'Select a jurisdiction';
            this.handleError("Warning", "Select a jurisdiction");
            validState = false;
        }
        if (!datalength) {
            validState = false;
        }
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentChargesUpdateState): IAgentChargesUpdateState => {
            previousState.hideModel = false;
            return previousState;
        });
    }
}